import Vue from 'vue';
import {VueAgile} from 'vue-agile';

export function initMemberCompanyCarousel(element: any) {
    if (!document.getElementById(element)) return;

    var vm = new Vue({
        el: '#' + element,
        components: {
            agile: VueAgile
        },
        data: function () {
            return {
                carouselOptions: {
                    navButtons: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    responsive: [
                        {
                            breakpoint: 925,
                            settings: {
                                slidesToShow: 4,
                                navButtons: true,
                                slidesToScroll: 4
                            }
                        },
                        {
                            breakpoint: 1050,
                            settings: {
                                slidesToShow: 5,
                                navButtons: true,
                                slidesToScroll: 5
                            }
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                slidesToShow: 3,
                                navButtons: true,
                                slidesToScroll: 3
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                navButtons: false,
                            }
                        }
                    ]
                }
            }
        },
        mounted: function () {
        },
        methods: {
        }
    });
}
